import React from "react";

export const CategoryThree = () => <h1>CategoryThree</h1>
